import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';
const CHECKOUT_URL = 'https://brain-dump-system.impultienda.ar/checkout';
const TARGET_HREF = {
  offer: '#offer',
  inside: '#inside',
  checkout: CHECKOUT_URL
} as const;
interface CtaButtonProps {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
  /** 'checkout' opens the checkout page, the others scroll to a section. */
  target?: 'offer' | 'inside' | 'checkout';
}
export function CtaButton({
  label,
  className = '',
  size = 'lg',
  target = 'checkout'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-4 text-sm sm:px-9 sm:text-base' : 'px-6 py-3 text-sm';
  const isCheckout = target === 'checkout';
  return <a href={TARGET_HREF[target]} onClick={isCheckout ? trackCheckoutStart : undefined} className={`inline-flex items-center justify-center rounded-full bg-brand-gold font-body font-black uppercase tracking-[0.04em] text-brand-deep shadow-lg shadow-[#25364a]/20 transition duration-200 hover:-translate-y-0.5 hover:bg-[#f8d9b8] hover:shadow-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-gold/60 ${sizing} ${className}`} data-id="element-1" data-mp="vcbr2m900kha">
      {label}
    </a>;
}